<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4" [class.pt-4]="!embedded">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [customizeColumns]="customizeColumns"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'time-logs-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Time Logs</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
            </dxo-toolbar>

            <dxi-column
                dataField="employee.name"
                caption="Employee"
                cellTemplate="employee"
                [minWidth]="250"
                [calculateFilterExpression]="nameOrEmailFilter"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('punchDate')"
                caption="Date"
                [minWidth]="100"
                dataType="date"
                [sortIndex]="0"
                [sortOrder]="'desc'"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('shiftCode')"
                caption="Shift"
                [minWidth]="100"
                alignment="center"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('firstPunchInTime')"
                caption="In"
                [minWidth]="100"
                cellTemplate="inTimes"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('punchInStatus')"
                caption="In Status"
                [minWidth]="100"
                cellTemplate="status"
                [lookup]="{ dataSource: clockInStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: clockInStatusOptions }"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('huddleStatus')"
                caption="Huddle"
                [minWidth]="100"
                cellTemplate="status"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('firstPunchOutTime')"
                caption="Out"
                [minWidth]="100"
                cellTemplate="outTimes"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('punchOutStatus')"
                caption="Out Status"
                [minWidth]="100"
                cellTemplate="status"
                [lookup]="{ dataSource: clockOutStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: clockInStatusOptions }"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('exceptionType')"
                caption="Exception Type"
                [minWidth]="150"
                [lookup]="{ dataSource: exceptionTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: exceptionTypeOptions }"
                [visible]="true"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('hasMealTicket')"
                caption="Meal Ticket"
                [minWidth]="100"
                dataType="boolean"
                cellTemplate="checkmark"
                [visible]="false"
            ></dxi-column>
            @if (auth.checkPermission(PermissionType.Checklist, AccessType.ViewOnly)) {
                <dxi-column
                    [dataField]="gridFieldName('checklistCompliance')"
                    caption="MHE"
                    [minWidth]="100"
                    dataType="boolean"
                    cellTemplate="compliance"
                    [lookup]="{ dataSource: checklistComplianceOptions, valueExpr: 'value', displayExpr: 'text' }"
                    [headerFilter]="{ dataSource: checklistComplianceOptions }"
                ></dxi-column>
            }
            <dxi-column
                [dataField]="gridFieldName('clearingExceptionReason')"
                caption="Reason"
                [minWidth]="150"
                [visible]="false"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('hoursWorkedSpan')"
                caption="Hours Worked"
                [minWidth]="100"
                [visible]="false"
                cellTemplate="hoursWorked"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('homeDepartmentCode')"
                caption="Home Department Code"
                [minWidth]="100"
                [visible]="false"
            ></dxi-column>
            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit"
                            [visible]="isEditVisible"></dxi-button>
                <dxi-button text="view" icon="eyeopen" hint="view" [onClick]="onView"></dxi-button>
            </dxi-column>
            <div *dxTemplate="let cellInfo of 'hoursWorked'">
                {{getCellData(cellInfo).hoursWorkedSpan | toDate | date: "H'h' m'min'" }}
            </div>
            <div *dxTemplate="let cellInfo of 'inTimes'">
                @for (time of getCellData(cellInfo).punchInTimes; track time) {
                    {{ time | toDate | date:"h:mm a" }}<br/>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'outTimes'">
                @for (time of getCellData(cellInfo).punchOutTimes; track time) {
                    {{ time | toDate | date:"h:mm a" }}<br/>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <contact-status [value]="cellInfo.value | dasherize"
                                [text]="cellInfo.value | capitalCase"></contact-status>
            </div>
            <div *dxTemplate="let cellInfo of 'employee'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name"
                    [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).employee.id"
                ></user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'checkmark'">
                @if (getCellData(cellInfo).hasMealTicket) {
                    <i class="fa-sharp fa-solid fa-badge-check text-success fs-5"></i>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'compliance'">
                @if (getCellData(cellInfo).checklistCompliance == ChecklistCompliance.Created) {
                    <i class="fa-sharp fa-solid fa-badge-check text-success fs-5"></i>
                }
                @else if (getCellData(cellInfo).checklistCompliance == ChecklistCompliance.Missing) {
                    <i class="fa-sharp fa-solid fa-seal-exclamation text-danger fs-5"></i>
                }
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                dataField="employee.name"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('punchDate')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Date', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('punchInStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Out Status',
                    stylingMode: 'filled',
                    items: clockInStatusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('punchOutStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'In Status',
                    stylingMode: 'filled',
                    items: clockOutStatusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('huddleStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Huddle',
                    stylingMode: 'filled',
                    items: huddleStatusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('shiftCode')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Shift', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('exceptionType')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Exception Type',
                    stylingMode: 'filled',
                    items: exceptionTypeOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('hasMealTicket')"
                editorType="dxCheckBox"
                [editorOptions]="{ text: 'Has Meal Ticket', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('clearingExceptionReason')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Reason', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <quick-view-panel
        [(isOpened)]="isQuickViewPanelOpened"
        (pinnedChange)="onPinnedChange()"
        [buttons]="buttons"
        [showToolbar]="isException()"
    >
        @if (selectedRow; as log) {
            <div class="p-3">
                <div class="mb-3 border-bottom pb-2">
                    <div class="text-uppercase small mb-1">Shift Details</div>
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <div class="fw-semibold fs-5">{{ log.punchDate | date: 'MMMM d, y' }}</div>
                            @if (log.shiftCode) {
                                <div class="small">
                                    Shift: {{ log.shiftCode }}
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center mb-3">
                    <user-avatar-email
                        [email]="log.employee.email"
                        [name]="log.employee.name"
                        [avatarUrl]="log.employee.avatarUrl"
                    ></user-avatar-email>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-12 col-md-6">
                        <div class="text-uppercase small">Shift Type</div>
                        <div class="fw-medium">{{ log.shiftType | capitalCase }}</div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="text-uppercase small">Shift Rate</div>
                        @if (log.shiftRate !== null) {
                            <div class="fw-medium">{{ log.shiftRate | currency }}</div>
                        }
                        @else{
                            <div class="fw-medium">—</div>
                        }
                    </div>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-12 col-md-6">
                        <div class="text-uppercase small mb-1">In</div>
                        <div class="mb-1 d-flex align-items-center">
                            <span class="small me-1">Scheduled:</span>
                            <span class="d-flex flex-column">
                                <span>{{ log.shiftStartTime | toDate | date:"h:mm a" }}</span>
                            </span>
                        </div>
                        <div class="mb-1 d-flex align-items-center">
                            <span class="small me-1">Times:</span>
                            <span class="d-flex flex-column">
                                @for (t of log.punchInTimes; track $index) {
                                    <span>{{ t | toDate | date:"h:mm a" }}</span>
                                } @empty {
                                    <span>—</span>
                                }
                            </span>
                        </div>
                        <div class="mb-1">
                            <span class="small me-1">Status:</span>
                            @if (log.punchInStatus) {
                                <contact-status
                                    [value]="log.punchInStatus | dasherize"
                                    [text]="log.punchInStatus | capitalCase"
                                ></contact-status>
                            } @else {
                                <span>—</span>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="text-uppercase small mb-1">Out</div>
                        <div class="mb-1 d-flex align-items-center">
                            <span class="small me-1">Scheduled:</span>
                            <span class="d-flex flex-column">
                                <span>{{ log.shiftEndTime | toDate | date:"h:mm a" }}</span>
                            </span>
                        </div>
                        <div class="mb-1 d-flex align-items-center">
                            <span class="small me-1">Times:</span>
                            <span class="d-flex flex-column">
                                @for (t of log.punchOutTimes; track $index) {
                                    <span>{{ t | toDate | date:"h:mm a" }}</span>
                                } @empty {
                                    <span>—</span>
                                }
                            </span>
                        </div>
                        <div class="mb-1">
                            <span class="small me-1">Status:</span>
                            @if (log.punchOutStatus) {
                                <contact-status
                                    [value]="log.punchOutStatus | dasherize"
                                    [text]="log.punchOutStatus | capitalCase"
                                ></contact-status>
                            } @else {
                                <span>—</span>
                            }
                        </div>
                    </div>
                    @if (log.huddleStatus) {
                        <div class="col-12">
                            <div class="mb-1">
                                <span class="small me-1">Huddle Status:</span>
                                <contact-status
                                    [value]="log.huddleStatus | dasherize"
                                    [text]="log.huddleStatus | capitalCase"
                                ></contact-status>
                            </div>
                            @for (huddle of log.lateHuddles; track $index) {
                                <div class="mb-1 small me-1 text-muted">
                                    Late:
                                    @if (huddle.initiator == HuddleInitiator.System) {
                                        System
                                    } @else {
                                        {{ (huddle.createdBy) }}
                                    }
                                    ({{ huddle.created | date:"h:mm a" }})
                                </div>
                            }
                        </div>
                    }
                </div>

                @if (log.scheduledHoursSpan || log.hoursWorkedSpan) {
                    <div class="border-top pt-2 mt-2">
                        <div class="row g-3">
                            @if (log.scheduledHoursSpan) {
                                <div class="col-12 col-md-6">
                                    <div class="text-uppercase small">Scheduled Hours</div>
                                    <div class="fw-medium">{{ log.scheduledHoursSpan | toDate | date: "H'h' m'min'" }}</div>
                                </div>
                            }
                            @if (log.hoursWorkedSpan) {
                                <div class="col-12 col-md-6">
                                    <div class="text-uppercase small">Hours Worked</div>
                                    <div class="fw-medium">{{ log.hoursWorkedSpan | toDate | date: "H'h' m'min'" }}</div>
                                </div>
                            }
                        </div>
                    </div>
                }

                @if (log.exceptionType != ExceptionType.None || log.clearingExceptionReason) {
                    <div class="border-top pt-2 mt-2">
                        <div class="text-uppercase small mb-1">Exception Details</div>
                        @if (log.exceptionType != ExceptionType.None) {
                            <div class="mb-1">
                                <span class="small me-1">Exception Type:</span>
                                <span class="fw-medium">{{ log.exceptionType | capitalCase }}</span>
                            </div>
                        }
                        @if (log.clearingExceptionReason) {
                            <div class="mb-1">
                                <span class="small me-1">Reason:</span>
                                <span class="fw-medium">{{ log.clearingExceptionReason }}</span>
                            </div>
                            <div class="mb-1">
                                <span class="fw-medium">
                                    {{ log.lastModifiedBy.name }}
                                </span>
                                <time class="text-muted ms-1">({{ log.lastModified | date:"longDate" }})</time>
                            </div>
                        }
                    </div>
                }

                @if (log.checklists.length > 0) {
                    @if (auth.checkPermission(PermissionType.Checklist, AccessType.ViewOnly)) {
                        <div class="border-top col-12 pt-2 mt-2">
                            <div class="mb-1">
                                <span class="small me-1">MHE Checklists</span>
                            </div>
                            @for (checklist of log.checklists; track $index) {
                                @if (checklist.checklistId) {
                                    <a [routerLink]="`/checklist/edit/${checklist.checklistId}`" target="_blank" class="mb-1 small me-1">
                                        {{ (checklist.number) }} ({{ checklist.created | date:"medium" }})
                                    </a>
                                } @else {
                                    <span class="mb-1 small me-1 text-danger">
                                    MHE has not been completed ({{ checklist.created | date:"medium" }})
                                </span>
                                }
                            }
                        </div>
                    }
                }
            </div>
        }
    </quick-view-panel>
    <clear-exceptions [(visible)]="isClearExceptionsPopupOpened" [timeLog]="selectedRow"
                      (onClear)="onExceptionCleared()"></clear-exceptions>
</div>
